// extracted by mini-css-extract-plugin
export var container = "_c6-0";
export var containerTopRight = "_c6-1";